import { TType } from '@translations/translationsTypes';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { InfoCircleOutlined } from '@ant-design/icons';
import { CustomButton } from '../CustomButton';

type Props = {
  show: boolean;
  onClose: () => void;
  t: TType;
};

export const ImportantIBSModal: React.FC<Props> = ({ show, onClose, t }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg" className="p-2">
      <Modal.Header closeButton>
        <InfoCircleOutlined className="me-2" size={48} />
        <Modal.Title>{t('ibs.important.read')}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <h6 className="fw-bold">Eligibility Requirements for In-Building Solution (IBS):</h6>

        <p color="#606F8A">
          To benefit from In-Building Solutions (IBS), a building must meet any one of the
          conditions, in accordance with the guidelines set by the Communications, Technology
          Technology Commission:
        </p>

        <ul color="#606F8A">
          <li>The building height is 7 floors or more.</li>
          <li>Includes 2 or more basement floors.</li>
          <li>Can accommodate 1000+ occupants at the same time.</li>
          <li>Any floor area is 3000+ square meters.</li>
        </ul>

        <hr />

        <h6 dir="rtl" className="fw-bold">
          شروط الأهلية للحصول على حلول التغطية الداخلية:
        </h6>

        <p dir="rtl" color="#606F8A">
          للاستفادة من خدمة حلول التغطية الداخلية، يجب أن يستوفي المبنى أيٌّ من الشروط التالية وفق
          ما حدّدته هيئة الاتصالات والفضاء والتقنية:
        </p>

        <ul dir="rtl" color="#606F8A">
          <li>ارتفاع المبنى 7 طوابق أو أكثر.</li>
          <li>يحتوي على طابقين سفليين أو أكثر.</li>
          <li>يتسع لـ 1000 شخص أو أكثر.</li>
          <li>مساحة الطابق 3000 متر مربع أو أكثر.</li>
        </ul>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end">
        <CustomButton variant="primary" onClick={onClose} text={t('understand')} />
      </Modal.Footer>
    </Modal>
  );
};
